import React, { useEffect, useState } from 'react';
import { getData } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';
import LayoutContent from '../../components/layouts/content2';
import { useTranslation } from 'react-i18next';
import ListProducts from './ListProducts';
import SpecialsScreen from './specials';
import CategoriesScreen from './categories';
import HappyHourScreen from './happyHour';
import ExecutivemenuScreen from './executiveMenu';
import BarScreen from './bar';
import SidesScreen from './sides';
import { useSelector } from 'react-redux';
import DetailProduct from './DetailProduct';
import BrunchScreen from './brunch';
import Guideline from './guidelines';
import QRCode from "react-qr-code";

function Index() {

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const {change, getInitData} = useRefresh();
    const [menus, setMenus] = useState([]);

    const [showSides, setShowSides] = useState(false);
     const [showListProduct, setShowListProduct] = useState(false);
    const [showSpecials, setShowSpecials] = useState(false);
    const [showCategories, setshowCategories] = useState(false);
    const [showHappy, setShowHappy] = useState(false);
    const [showExecutiveMenu, SetshowExecutiveMenu] = useState(false);
    const [showBar, setShowBar] = useState(false);
    const [dishs, setdishs] = useState(false);
    const [drinks, setdrinks] = useState(false);
     const [showDetailProduct, setShowDetailProduct] = useState(false);
    const [dataDish, setDataDish] = useState(false);
    const [dataAppetizers, setDataAppetizers] = useState(false);
    const [dataEntress, setdataEntress] = useState(false);
    const [soups, setsoups] = useState(false);
    const [dataDesserts, setdataDesserts] = useState(false);
     const [datasish, setdatasish] = useState(false);
      const [valentine, setvalentine] = useState([]);
     const [shakira, setShakira] = useState(false);
    const [driks, setdriks] = useState(false);
    const [showbrunch, setShowbrunch] = useState(false);
    const [dataBrucnh, setdataBrucnh] = useState(false);
    const [datakarol, setdatakarol] = useState(false);
    const [datahousetequila, setdatahousetequila] = useState(false);
    const [showGuideline, setGuideLine] = useState(false);

    const [showModal, setShowModal] = useState(false);
    
    const [showSocial, setShowSocial] = useState(false);


     const {
       goHomeInit
     } = useSelector((state) => state.initLoad);
    

    
    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
           
            setMenus(data);
        });
    }, [change]);


      useEffect(() => {
            menus.map((item) => {
                if (item.id === 479) {
                    setdrinks(item);
                    
                }
                if (item.id === 461) {
                    setDataAppetizers(item);
                }
                if (item.id === 482) {
                    setdataEntress(item);
                }
                if (item.id === 486) {
                    setsoups(item);
                }
                if (item.id === 490) {
                    setdataDesserts(item);
                }
                if (item.id === 494) {
                    setvalentine(item.menus);
                }
                if (item.id === 497) {
                    setdatahousetequila(item.menus);
                }
                if (item.id === 633) {
                    setdataBrucnh(item)
                }
                
               
            });
      }, [menus]);
    
    
    useEffect(() => {
    if (valentine) {
      valentine.map((item) => {
        if (item.id === 4910) {
          setdatasish(item);
        }
          
          if (item.id === 4910) {
          setdatasish(item);
          }



          
          if (item.id === 4023) {
              setShakira(item);
            }
      });
    }
    }, [valentine]);
    
     useEffect(() => {
    if (datahousetequila) {
      datahousetequila.map((item) => {
       
          if (item.id === 4060) {
          setdatakarol(item);
          }
      });
    }
  }, [datahousetequila]);
    
    

     useEffect(() => {
            console.log(goHomeInit, 'q mas qlq')
              setShowListProduct(false);
            setShowSpecials(false)
            setShowHappy(false)
            SetshowExecutiveMenu(false)
            setShowBar(false)
            setshowCategories(false)
            setShowSides(false)
            setShowDetailProduct(false)
     }, [goHomeInit]);
    
    useEffect(() => {
        const handleVisibilityChange = () => {
        if (document.visibilityState === "hidden") {
            console.log("La página ha perdido el foco (está oculta).");
            setShowListProduct(false);
            setShowSpecials(false)
            setShowHappy(false)
            SetshowExecutiveMenu(false)
            setShowBar(false)
            setshowCategories(false)
            setShowSides(false)
            setShowDetailProduct(false)
            getInitData()

        } else if (document.visibilityState === "visible") {
            console.log("La página está en foco (visible).");
        }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        // Limpieza del evento al desmontar el componente
        return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);

    window.onerror = function () {
        console.log('Error global detectado, recargando...');
        setTimeout(() => {
            window.location.reload();
        }, 2000);
        };

    

    return (
         <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
        <LayoutContent showBack={false} showImageTop={true} setShowSpecials={() => {
            setdishs(drinks)
            setShowListProduct(true)
            }} goCategories={setshowCategories}>

            {
                    showSocial &&
                    <div
                        onClick={() => setShowSocial(false)}
                        style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            background: 'rgba(0, 0, 0, 0.7)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: 99999,
                        }}
                    >
                        <div
                            onClick={(e) => e.stopPropagation()}
                            style={{
                                position: 'relative',
                             
                                padding: 20,
                                borderRadius: 12,
                                boxShadow: '0 10px 40px rgba(0,0,0,0.4)',
                            }}
                        >
                            <div
                                onClick={() => setShowSocial(false)}
                                style={{
                                    position: 'absolute',
                                    top: 10,
                                    right: 15,
                                    cursor: 'pointer',
                                    fontSize: 28,
                                    lineHeight: 1,
                                    color: '#b30303',
                                    fontWeight: 'bold',
                                }}
                            >
                                ×
                            </div>
                            <img src={require(
                                showSocial === 'ig' ? './assets/qrig.png' :
                                showSocial === 'tk' ? './assets/qrtk.png' :
                                showSocial === 'fb' ? './assets/qrfb.png' :
                                './assets/qrig.png'
                            )} style={{objectFit: 'contain', width: 400, height: 400}} />
                        </div>
                    </div>
            }
                
            <div style={{display: 'flex',paddingBlock: 5,alignItems: 'center',justifyContent: "space-between",background: '#b30303', position: "absolute", zIndex: 999, width: '100%', top: 0, left: 0}}>
                <div style={{display: "flex", gap: 20,  marginLeft: 20}}>
                    <div onClick={()=>setShowSocial('ig')}>
                        <img src={require('./assets/instagram.png')} style={{objectFit: 'contain', width: 35, height: 35}} />
                    </div>    
                    <div onClick={()=>setShowSocial('tk')}>
                        <img src={require('./assets/tiktok.png')}style={{objectFit: 'contain', width: 35, height: 35}} />
                    </div>     
                    <div onClick={()=>setShowSocial('fb')}>
                        <img src={require('./assets/facebook.png')}style={{objectFit: 'contain', width: 35, height: 35}} />
                    </div>     
                </div>
                <div style={{marginLeft: 30}} onClick={()=>setShowModal('https://supple.live/3yWbSaM')}>
                    <img src={require('./assets/giveus.png')} style={{objectFit: 'contain', width: 230, height: 50}} />
                </div>
                <div onClick={()=>setGuideLine(true)} style={{marginRight: 20}}>
                    <img src={require('./assets/clickhere.png')} style={{objectFit: 'contain', width: 210, height: 40}} />
                </div>
                   
            </div>
            <div>
                    <div style={{ width: '100%' }}>
                       
                    <img
                        style={{
                            width: 330,
                            height: 170,
                            justifyContent: 'center',
                            objectFit: 'contain',
                            zIndex: 100,
                            alignSelf: 'center',
                            marginTop: -25,
                            marginBottom: -20
                            
                        }}
                        src={require('./assets/logo.png')}
                    />
                </div>
                <div style={{ display: 'flex', width: '100%',  gap: 20,position: 'relative', zIndex: 100,  paddingInline: 20, boxSizing: 'border-box' }}>
                       
                        <div style={{ width: '40%' }}
                            onClick={() => {
                            setShowDetailProduct(true)
                    setDataDish({ dish: datakarol, alldish: valentine, currentDish: datakarol })
                        }}
                        >
                            <video
                                
                             onClick={() => {
                               /// setShowDetailProduct(true)
                                ///setDataDish({ dish: shakira, alldish: driks, currentDish: shakira })
                            }}
                            src={require('./assets/banner2.mp4')}
                            loop autoPlay={true} muted 
                            style={{
                                width: '100%',
                                height: 480,
                                objectFit: 'cover',
                                borderRadius: 14,
                               
                            }}
                        />

                    </div>
                    <div style={{ width: '60%', background: 'white', height: 480,borderRadius: 10, paddingInline: 20, boxSizing: 'border-box'}}>

                       <div
                            onClick={() => {
                               
                            }}
                            style={{width: '100%', marginTop: -35, marginLeft: -7}}>
                            <img
                                onClick={()=> setShowHappy(true)}
                                style={{
                                width: 420,
                                height: 210,
                                borderRadius: 14,
                                objectFit: 'contain',
                                }}
                                src={require('./assets/drinks.png')}
                            />
                        </div>

                        
                         <div style={{flexDirection: 'row', marginTop: 5, display: "flex"}}>
                            <div
                                onClick={() => {
                                    setdishs(dataAppetizers);
                                    setShowListProduct(true)
                                }}
                                style={{width: '47.6%', marginRight: 12}}>
                                <img
                                style={{
                                    width: 175,
                                    height: 90,
                                    borderRadius: 14,
                                    objectFit: 'cover',
                                }}
                                src={require('./assets/appetizers.png')}
                                />
                            </div>
                            <div
                                onClick={() => {
                                setdishs(dataEntress);
                                    setShowListProduct(true)
                                }}
                                style={{width: '47.6%'}}>
                                <img
                                style={{
                                    width: 175,
                                    height: 90,
                                    borderRadius: 14,
                                    objectFit: 'cover',
                                }}
                                src={require('./assets/entrees.png')}
                                />
                            </div>
                        </div>

                        <div
                            onClick={() => {
                               setdishs(soups);
                                    setShowListProduct(true)
                            }}
                            style={{width: '100%', marginTop: 1}}>
                            <img
                                style={{
                                width: '100%',
                                height: 59.8,
                                borderRadius: 14,
                                objectFit: 'contain',
                                }}
                                src={require('./assets/soups.png')}
                            />
                        </div>

                         <div >
                            <div
                                onClick={() => {
                                    setdishs(dataDesserts);
                                    setShowListProduct(true)
                                }}
                                style={{width: '100%'}}>
                                <img
                                style={{
                                    width: '100%',
                                    height: 60,
                                    borderRadius: 14,
                                    objectFit: 'contain',
                                }}
                                src={require('./assets/dessertshome.png')}
                                />
                            </div>
                            <div
                                onClick={() => {
                                  
                                    setShowSides(true)
                                }}
                                style={{width: '100%'}}>
                                <img
                                style={{
                                    width: '100%',
                                    height: 65,
                                    borderRadius: 14,
                                        objectFit: 'contain',
                                }}
                                src={require('./assets/sides.png')}
                                />
                            </div>
                        </div>
                        

                        
                        {/* <img
                            onClick={() => {
                                setDataDish({ dish: dataDrink, alldish: drinks.menus})
                                setShowDetailProduct(true)
                            }}
                            style={{
                                      marginTop: 7,
                                    width: '100%',
                                    height: 245,
                                    objectFit: 'contain',
                                    borderRadius: 14,
                                }}
                                src={require('./assets/banner3.png')}
                            /> */}
                    </div>
                </div>
               
            </div>

            <div
                onClick={() => {
                   // setShowDetailProduct(true)
                    //setDataDish({ dish: datasish, alldish: valentine, currentDish: datasish })
                }}
                style={{
                    width: '100%',
                    alignItems: 'center',
                    paddingInline: 20,
                    boxSizing: 'border-box',
                    marginTop: -13
                   
                }}>
                <video
                    src={require('./assets/Laotrabanner.mp4')}
                    loop autoPlay={true} muted 
                    style={{
                        width: '100%',
                        height: 225,
                        objectFit: 'contain',
                        borderRadius: 15,
                     
                    }}
                />
                </div>
                
                <div style={{  width: '90%', margin: '-14px auto 0'}}>
                    <p
                  style={{
                      color: '#000',
                      fontWeight: '300',
                      textAlign: 'center',
                            fontSize: 15,
                      lineHeight: 1.2
                    }}>
                  Please inform the waiter if you have any type of allergic condition.
For your convenience, an 18% gratuity will be added to your bill.  A 3% fee will be added 
for card payments.
                    </p>
                  
                     {/* <p
                  style={{
                      color: '#000',
                      fontWeight: '300',
                      textAlign: 'center',
                            fontSize: 15,
                      lineHeight: 1.2
                    }}>
                      if you feel that your service was not satisfactory we will take it off
                    </p> */}
                </div>


                {showModal &&  <div onClick={()=>setShowModal(false)} style={{position: 'absolute', top: 0, bottom: 0, left: 0,width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#00000063', zIndex: 9999}}>
              <QRCode
              size={256}
              style={{ height: 400,  width: 400 }}
              value={showModal}
              divBox={`0 0 256 256`}
            />
            </div>}

            {showListProduct && <ListProducts
                dishs={dishs}
                setShowListProduct={setShowListProduct}
            />}

            {showSides && <SidesScreen setShowHappy={setShowSides} />}
            
            {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
            {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} />}
            {showHappy && <HappyHourScreen setShowHappy={setShowHappy} />}
            {showExecutiveMenu && <ExecutivemenuScreen SetshowExecutiveMenu={SetshowExecutiveMenu} />}
            
                {showBar && <BarScreen setShowBar={setShowBar} />}
                
                {showbrunch && <BrunchScreen setShowHappy={setShowbrunch} />}
                {showGuideline && <Guideline setShowHappy={setGuideLine} />}
            

            {showDetailProduct && <DetailProduct
                    dishMenu={dataDish}
                    setShowListProduct2={setShowListProduct}
                    setShowDetailProduct={setShowDetailProduct}
            />}
            
            
            </LayoutContent>
            </div>
    );
}

export default Index;